// frontend/src/pages/NewUITerms.jsx
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const NewUITerms = () => {
    // Aplicar scope de Acumin
    useEffect(() => {
        document.body.classList.add('acumin-scope');
        return () => {
            document.body.classList.remove('acumin-scope');
        };
    }, []);

    return (
        <div
            className="min-h-screen pt-24 pb-12 px-4 sm:px-6 lg:px-8"
            style={{
                backgroundImage: 'url(/images/backgrounds/hero-radial-bg.png)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
            }}
        >
            <div className="max-w-4xl mx-auto">
                {/* Header */}
                <div className="text-center mb-8">
                    <h1
                        className="toon toon-3d text-3xl md:text-4xl lg:text-5xl font-extrabold uppercase mb-4"
                        style={{
                            WebkitTextStroke: "1px #000",
                            textShadow: "0 2px 0 rgba(0,0,0,1), 0 4px 2px rgba(0,0,0,1)"
                        }}
                    >
                        Términos y Condiciones
                    </h1>
                </div>

                {/* Content Card */}
                <div
                    className="rounded-[24px] overflow-hidden shadow-[0_20px_60px_rgba(0,0,0,0.5)]"
                    style={{
                        backgroundColor: '#122436',
                        border: '2px solid rgba(255,255,255,0.55)'
                    }}
                >
                    <div className="p-6 sm:p-8">
                        {/* Scrollable Content */}
                        <div
                            className="max-h-[70vh] overflow-y-auto pr-4 custom-scrollbar"
                            style={{
                                scrollbarWidth: 'thin',
                                scrollbarColor: '#2284DF rgba(255,255,255,0.1)'
                            }}
                        >
                            <style jsx>{`
                                .custom-scrollbar::-webkit-scrollbar {
                                    width: 8px;
                                }
                                .custom-scrollbar::-webkit-scrollbar-track {
                                    background: rgba(255,255,255,0.05);
                                    border-radius: 4px;
                                }
                                .custom-scrollbar::-webkit-scrollbar-thumb {
                                    background: #2284DF;
                                    border-radius: 4px;
                                }
                                .custom-scrollbar::-webkit-scrollbar-thumb:hover {
                                    background: #2A91F4;
                                }
                            `}</style>

                            {/* Sección 01 */}
                            <section className="mb-8">
                                <h2 className="text-xl font-extrabold text-[#FCE503] mb-4 uppercase tracking-wider">
                                    01 ACERCA DE ESTE ACUERDO
                                </h2>
                                <div className="space-y-4 text-white/80 text-sm leading-relaxed">
                                    <p>1.1. Lea este acuerdo en su totalidad ("Acuerdo" o "Términos"). Es un contrato entre usted y Mano Ganadora. El acceso y uso del sitio web de Mano Ganadora ("Sitio web") y los servicios (el Sitio web y otros servicios, colectivamente, se denominan los "Servicios") está expresamente condicionado a la aceptación de este Acuerdo.</p>

                                    <p>1.2. LEA ATENTAMENTE LA CLÁUSULA DE ARBITRAJE VINCULANTE Y LA RENUNCIA A LA DEMANDA COLECTIVA EN LA SECCIÓN 9. AFECTA LA FORMA EN QUE SE RESUELVEN LAS DISPUTAS ENTRE USTED Y MANO GANADORA.</p>

                                    <div
                                        className="p-4 rounded-lg"
                                        style={{
                                            backgroundColor: 'rgba(252, 229, 3, 0.1)',
                                            border: '1px solid rgba(252, 229, 3, 0.3)'
                                        }}
                                    >
                                        <p className="text-[#FCE503]">
                                            <strong>NOTA:</strong> Dependiendo de dónde resida, puede tener derechos bajo las leyes locales aplicables que no se pueden limitar ni renunciar.
                                        </p>
                                    </div>

                                    <p>1.3. Para aceptar estos Términos y crear una Cuenta, debe tener al menos 18 años de edad y haber alcanzado la mayoría de edad legal en el país en el que está registrada su cuenta.</p>

                                    <p>1.4. Todos los Torneos ofrecidos en el Sitio web son "juegos de habilidad". El ganador se determina en función del desempeño del usuario y la posición que ocupe al final del Torneo.</p>
                                </div>
                            </section>

                            {/* Sección 02 */}
                            <section className="mb-8">
                                <h2 className="text-xl font-extrabold text-[#FCE503] mb-4 uppercase tracking-wider">
                                    02 SERVICIOS DE TERCEROS
                                </h2>
                                <div className="space-y-4 text-white/80 text-sm leading-relaxed">
                                    <p>2.1. También podemos proporcionar acceso (pago o gratuito) a contenido, productos o servicios ofrecidos por editores o entidades distintas de Mano Ganadora y sus asociados ("Servicios de terceros").</p>

                                    <p>2.2. "Contenido de Mano Ganadora" incluye juegos, películas, videos, música, servicios, cupones, moneda virtual, comunidades virtuales y otros productos o contenidos digitales a través de nuestros Servicios.</p>

                                    <p>2.3. Mano Ganadora no responde por los Servicios de terceros promocionados o sobre los Servicios.</p>
                                </div>
                            </section>

                            {/* Sección 03 */}
                            <section className="mb-8">
                                <h2 className="text-xl font-extrabold text-[#FCE503] mb-4 uppercase tracking-wider">
                                    03 CREACIÓN Y USO DE LA CUENTA
                                </h2>
                                <div className="space-y-4 text-white/80 text-sm leading-relaxed">
                                    <p>3.1. Toda la información proporcionada durante la creación de la Cuenta debe ser precisa. Nos reservamos el derecho de suspender, cancelar o restringir cualquier Cuenta que utilice o haya sido creada utilizando información falsa.</p>

                                    <p>3.2. Puede establecer solo una cuenta por persona para participar en los Servicios ofrecidos en el Sitio web.</p>

                                    <p>3.3. Todos los usuarios deben proteger su ID de inicio de sesión, contraseña, clave de acceso u otra información de autenticación de la Cuenta.</p>

                                    <p>3.4. Mano Ganadora tiene el derecho de denegar la creación de cualquier Cuenta, por cualquier motivo, a su exclusivo criterio.</p>
                                </div>
                            </section>

                            {/* Sección 04 */}
                            <section className="mb-8">
                                <h2 className="text-xl font-extrabold text-[#FCE503] mb-4 uppercase tracking-wider">
                                    04 CÓDIGO DE CONDUCTA
                                </h2>
                                <div className="space-y-4 text-white/80 text-sm leading-relaxed">
                                    <p>Los Servicios son para todos, independientemente de su raza, identidad de género, orientación sexual, etnia, nacionalidad, color, estado migratorio, clase social y económica, nivel educativo, creencias políticas, religión y capacidad física y mental.</p>

                                    <div
                                        className="p-4 rounded-lg space-y-3"
                                        style={{
                                            backgroundColor: 'rgba(255,255,255,0.05)',
                                            border: '1px solid rgba(255,255,255,0.1)'
                                        }}
                                    >
                                        <p className="font-bold text-white">Reglas esenciales:</p>
                                        <ul className="space-y-2 text-sm">
                                            <li>✓ Sea inclusivo</li>
                                            <li>✗ No haga ni diga nada que incite al odio</li>
                                            <li>✗ No amenace, dañe ni alarme a nadie</li>
                                            <li>✗ No intimide, acose ni aceche a nadie</li>
                                            <li>✓ Sea sensato. Respete la ley</li>
                                            <li>✗ No sea vulgar ni ofensivo</li>
                                            <li>✗ No haga trampas</li>
                                            <li>✓ Sea amable y respetuoso</li>
                                        </ul>
                                    </div>
                                </div>
                            </section>

                            {/* Sección 05 */}
                            <section className="mb-8">
                                <h2 className="text-xl font-extrabold text-[#FCE503] mb-4 uppercase tracking-wider">
                                    05 CONTENIDO GENERADO POR EL USUARIO
                                </h2>
                                <div className="space-y-4 text-white/80 text-sm leading-relaxed">
                                    <p>5.1. Podemos proporcionar una funcionalidad que le permita crear, publicar o transmitir contenido como texto, mensajes, comentarios, capturas de pantalla, imágenes, fotografías, voz, música, videos, transmisiones e información relacionada con el juego.</p>

                                    <p>5.2. Al utilizar dicha funcionalidad, usted otorga a Mano Ganadora una licencia global, perpetua y libre de regalías para usar, distribuir, copiar, modificar, mostrar y publicar su contenido por cualquier motivo.</p>

                                    <p>5.3. Nos reservamos el derecho de suprimir, bloquear, ocultar, eliminar o borrar cualquier contenido a nuestra discreción.</p>
                                </div>
                            </section>

                            {/* Sección 06 */}
                            <section className="mb-8">
                                <h2 className="text-xl font-extrabold text-[#FCE503] mb-4 uppercase tracking-wider">
                                    06 LICENCIA Y RESTRICCIÓN DE CONTENIDO
                                </h2>
                                <div className="space-y-4 text-white/80 text-sm leading-relaxed">
                                    <p>6.1. Todos los derechos de propiedad intelectual que subsisten en nuestro Contenido pertenecen a Mano Ganadora, sus asociados y sus licenciantes.</p>

                                    <p>6.2. Todo el Contenido proporcionado a través de los Servicios se le otorga bajo licencia no exclusiva y revocable para su uso personal, privado, intransferible y no comercial.</p>

                                    <p>6.3. No podrá vender, alquilar, arrendar, prestar, sublicenciar, modificar, adaptar, organizar, traducir, aplicar ingeniería inversa, descompilar ni desensamblar ninguna parte del Contenido.</p>
                                </div>
                            </section>

                            {/* Sección 07 */}
                            <section className="mb-8">
                                <h2 className="text-xl font-extrabold text-[#FCE503] mb-4 uppercase tracking-wider">
                                    07 BILLETERA VIRTUAL
                                </h2>
                                <div className="space-y-4 text-white/80 text-sm leading-relaxed">
                                    <p>7.1. Su cuenta tiene una billetera virtual asociada, que puede almacenar fondos de un método de pago externo.</p>

                                    <p>7.2. Los fondos de la billetera no tienen valor fuera de Mano Ganadora y solo se pueden usar para realizar compras a través de los Servicios.</p>

                                    <p className="font-bold text-white">7.3. LOS FONDOS AGREGADOS A SU BILLETERA NO SON REEMBOLSABLES NI TRANSFERIBLES, EXCEPTO CUANDO LA LEY LO REQUIERA.</p>
                                </div>
                            </section>

                            {/* Sección 08 */}
                            <section className="mb-8">
                                <h2 className="text-xl font-extrabold text-[#FCE503] mb-4 uppercase tracking-wider">
                                    08 CANCELACIÓN Y SUSPENSIÓN DE CUENTA
                                </h2>
                                <div className="space-y-4 text-white/80 text-sm leading-relaxed">
                                    <p>8.1. <strong className="text-white">Cuentas inactivas:</strong> Si su cuenta no tiene actividad durante seis (6) meses, se considerará inactiva. Mano Ganadora aplicará una tarifa de inactividad mensual a todas las cuentas inactivas.</p>

                                    <p>8.2. <strong className="text-white">Terminación por su parte:</strong> Puede terminar su cuenta en cualquier momento comunicándose con el servicio de asistencia.</p>

                                    <p>8.3. <strong className="text-white">Suspensión o terminación:</strong> Podemos suspender o terminar cualquier cuenta en caso de una violación de este Acuerdo.</p>
                                </div>
                            </section>

                            {/* Sección 09 */}
                            <section className="mb-8">
                                <h2 className="text-xl font-extrabold text-[#FCE503] mb-4 uppercase tracking-wider">
                                    09 ARBITRAJE Y RESOLUCIÓN DE DISPUTAS
                                </h2>
                                <div className="space-y-4 text-white/80 text-sm leading-relaxed">
                                    <p>9.1. Cualquier disputa, reclamo o controversia entre usted y Mano Ganadora se resolverá mediante arbitraje individual vinculante.</p>

                                    <p className="font-bold text-white">9.2. RENUNCIA A LA DEMANDA COLECTIVA: USTED Y MANO GANADORA ACUERDAN QUE EL ARBITRAJE SE LLEVARÁ A CABO SOLO DE FORMA INDIVIDUAL Y NO EN UNA DEMANDA COLECTIVA.</p>

                                    <p>9.3. El procedimiento de arbitraje se realizará de acuerdo con las normas establecidas por la Cámara de Comercio de la Ciudad de Mendoza.</p>
                                </div>
                            </section>

                            {/* Sección 10 */}
                            <section className="mb-8">
                                <h2 className="text-xl font-extrabold text-[#FCE503] mb-4 uppercase tracking-wider">
                                    10 LEY APLICABLE Y JURISDICCIÓN
                                </h2>
                                <div className="space-y-4 text-white/80 text-sm leading-relaxed">
                                    <p>Las leyes de la República Argentina, sin tener en cuenta las normas sobre conflicto de leyes, rigen este Acuerdo. Cualquier disputa será presentada en los Tribunales Ordinarios de la Primera Circunscripción de la Provincia de Mendoza.</p>
                                </div>
                            </section>

                            {/* Sección 11 */}
                            <section className="mb-8">
                                <h2 className="text-xl font-extrabold text-[#FCE503] mb-4 uppercase tracking-wider">
                                    11 EXENCIÓN DE RESPONSABILIDAD
                                </h2>
                                <div className="space-y-4 text-white/80 text-sm leading-relaxed">
                                    <p>No se otorga garantía alguna sobre la calidad, funcionalidad, disponibilidad o rendimiento de los Servicios. Todos los Servicios se proporcionan "TAL CUAL" y "SEGÚN DISPONIBILIDAD" con todos los defectos.</p>

                                    <p className="font-bold text-white">EXCLUIMOS TODA RESPONSABILIDAD POR CUALQUIER PÉRDIDA DE DATOS, DAÑO CAUSADO A SU SOFTWARE O HARDWARE Y CUALQUIER OTRA PÉRDIDA O DAÑO SUFRIDO POR USTED.</p>
                                </div>
                            </section>

                            {/* Sección 12 */}
                            <section className="mb-8">
                                <h2 className="text-xl font-extrabold text-[#FCE503] mb-4 uppercase tracking-wider">
                                    12 INFORMACIÓN DE CONTACTO
                                </h2>
                                <div className="space-y-4 text-white/80 text-sm leading-relaxed">
                                    <p>Para obtener más información o si tiene preguntas sobre su Cuenta, comuníquese con el servicio de asistencia.</p>
                                </div>
                            </section>

                            {/* Footer */}
                            <div className="mt-8 pt-6 border-t border-white/10 text-center">
                                <p className="text-sm text-white/50">
                                    Última actualización: Febrero 2025
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Back to home link */}
                <div className="mt-8 text-center">
                    <Link
                        to="/"
                        className="inline-flex items-center gap-2 text-white/80 hover:text-white transition-colors font-semibold"
                    >
                        <svg
                            className="w-5 h-5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M10 19l-7-7m0 0l7-7m-7 7h18"
                            />
                        </svg>
                        Volver al inicio
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default NewUITerms;